/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_LabelInputs */

const en_cap_full_label = /** @type {(inputs: Cap_Full_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full systems`)
};

const lv_cap_full_label = /** @type {(inputs: Cap_Full_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilnas sistēmas`)
};

/**
* | output |
* | --- |
* | "Full systems" |
*
* @param {Cap_Full_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_label = /** @type {((inputs?: Cap_Full_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_label(inputs)
	return en_cap_full_label(inputs)
});